export interface PresetIds {
  prod: string
  staging: string
  dev: string
}

const env = import.meta.env.REACT_APP_ENV! as 'prod' | 'staging' | 'dev'

export const CLIENT_AND_ADVISOR_FOLLOW_UPS_PRESET_IDS: PresetIds = {
  dev: '9xbrgp80b4ls6qbx',
  staging: '9xbrgp80b4ls6qbx',
  prod: 'cqkkd1xbz240b6b7',
}
export const MEETING_PURPOSE_PRESET_IDS: PresetIds = {
  dev: '6c5b67xk6eca2pqw',
  staging: '3h5ru2ul1ibei8nr',
  prod: 'cinohoyphbq9k6ze',
}
export const FUTURE_MEETINGS_PRESET_IDS: PresetIds = {
  dev: '0wjli2zuhql13b8c',
  staging: '70952walunyoh784',
  prod: 'cvlbyfpvcpn8lm79',
}
export const DECISION_TRACKER_PRESET_IDS: PresetIds = {
  dev: '9whazww8yjy46lgj',
  staging: 'dn9zmze8myeyz88n',
  prod: '43xag2xhmag1kzty',
}
export const LIST_OF_LIFE_EVENTS_PRESET_IDS: PresetIds = {
  dev: 'br7rn1mfwcd505b8',
  staging: '7y0msdkjb0crtm8s',
  prod: 'bt7ql6pg95m1f4gi',
}
export const ADVISOR_REFERRAL_PRESET_IDS: PresetIds = {
  dev: 'ei761cpe41z8xkam',
  staging: '4xy3da295bfs74oq',
  prod: '9spy1cuwspkqyroe',
}
export const NON_FINANCIAL_PERSONAL_INFORMATION_PRESET_IDS: PresetIds = {
  dev: 'evnxc5g83s79fuxs',
  staging: '7b5mamvpshqal48g',
  prod: 'cg4p5233f13wofan',
}
export const CONVERSATION_TIMELINE_PRESET_IDS: PresetIds = {
  dev: 'bexymmkg4wy1bt19',
  staging: 'bexymmkg4wy1bt19',
  prod: '1yeurmenhtv0mxsx',
}
export const FAMILY_TREE_PRESET_IDS: PresetIds = {
  dev: '18fjyrkvwljdyu0v',
  staging: 'acdqro1x32p6wck6',
  prod: '63v2pjlbax3rlqdh',
}
export const FOLLOW_UP_EMAIL_PRESET_IDS: PresetIds = {
  dev: 'aur41tqdihe9u1kd',
  staging: 'dxq0qfghf7kekksd',
  prod: 'ekg2bcro6o85d6qw',
}
export const FINANCIAL_SUMMARY_PRESET_IDS: PresetIds = {
  dev: 'eiaibj6g6uuxmfbu',
  staging: 'eudwatduwtujes7r',
  prod: '2tspyef3f59unqyl',
}
export const TOPICS_COVERED_PRESET_IDS: PresetIds = { dev: '94ll6419sd3tgv3a', staging: '', prod: '5c991i65a5bfqiyp' }
export const DISCUSSION_TOPICS_PRESET_IDS: PresetIds = {
  dev: '0ieni417lb55fkwe',
  staging: '7hs3tnx0s7qnm8f2',
  prod: '313x4r6ost80f5za',
}

export const TASK_PRESET_IDS = [CLIENT_AND_ADVISOR_FOLLOW_UPS_PRESET_IDS[env]]
export const NOTE_PRESET_IDS = [MEETING_PURPOSE_PRESET_IDS[env]]
export const EVENT_PRESET_IDS = [FUTURE_MEETINGS_PRESET_IDS[env]]
